module.exports = __webpack_public_path__ + "static/media/Filter.209e8846.png";